/* eslint-disable no-unused-vars */
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, onMessage, getToken } from "firebase/messaging";
import { getAnalytics } from "firebase/analytics";
import { getFunctions } from "firebase/functions";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

import {
  getAuth,
  createUserWithEmailAndPassword,
  getAdditionalUserInfo,
  updateProfile,
  // connectAuthEmulator,
  // sendSignInLinkToEmail,
  // linkWithCredential,
  // EmailAuthProvider,
  // signInWithEmailLink,
} from "firebase/auth";
import {
  // connectFirestoreEmulator,
  getFirestore,
} from "firebase/firestore";
import { CreateUserRecord } from "./controllers/auth/CreateUserRecord";
import { CreateBusinessRecord } from "./controllers/auth/CreateBusinessRecord";
import sha256 from "./controllers/auth/sha256";
import { AuthErrorMessages } from "./controllers/auth/AuthErrorMessages";
import SeedBusinessRecord from "./controllers/auth/SeedBusinessRecord";
// import { connectStorageEmulator, getStorage } from "firebase/storage";
import { createSubCollectionInClient } from "./controllers/dynamicFields/createSubCollectionInClient";
import { getCompleteCollection } from "./controllers/dynamicFields/getCompleteCollection";
import SeedUserRole from "./controllers/auth/SeedUserRole";
import { setDoc, doc } from "firebase/firestore";
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const production = process.env.REACT_APP_MY_PRODUCTION;

let firebaseConfig;
if (process.env.REACT_APP_MY_PRODUCTION == 0) {
  firebaseConfig = {
    apiKey: "AIzaSyCy0zzLex_qFYtlqGKC7J_nmaxiLQv5I0U",
    authDomain: "landbook-qa.firebaseapp.com",
    projectId: "landbook-qa",
    storageBucket: "landbook-qa.appspot.com",
    messagingSenderId: "920861139555",
    appId: "1:920861139555:web:cddbcdcd060f3c32a0ce56",
    measurementId: "G-NHEKFDYJ7K",
  };
} else {
  firebaseConfig = {
    apiKey: "AIzaSyAQvqOi_x7yFEvLXJeFO5cfdIpxK4SIf9A",
    authDomain: "property-management-port-12157.firebaseapp.com",
    projectId: "property-management-port-12157",
    storageBucket: "property-management-port-12157.appspot.com",
    messagingSenderId: "483936075466",
    appId: "1:483936075466:web:a99794bf8609e33d107e33",
    measurementId: "G-J2T08JFN3S",
  };
}

/**
 * In development mode on localhost
 * configuring the database u
 */

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);

let appCheck;

if (process.env.REACT_APP_MY_PRODUCTION == 0) {
  appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(
      "6Lf80UghAAAAAGZkatFMFeX2wUYSBp9x7VZ1LiVG"
    ),

    isTokenAutoRefreshEnabled: true,
  });
} else {
  appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(
      "6Lf80UghAAAAAGZkatFMFeX2wUYSBp9x7VZ1LiVG"
    ),

    isTokenAutoRefreshEnabled: true,
  });
}

/**
 * Emulators configuration
 */
if (process.env.NODE_ENV === "development") {
  // connectAuthEmulator(
  //   getAuth(),
  //   process.env.REACT_APP_FIREBASE_AUTH_EMULATOR_HOST
  // );
  // connectFirestoreEmulator(
  //   db,
  //   "127.0.0.1",
  //   process.env.REACT_APP_FIREBASE_FIRESTORE_EMULATOR_PORT
  // );
  // connectStorageEmulator(getStorage(), "localhost", 9199);
}

export const RegisterUser = async (Name, Email, Password, Business) => {
  return createUserWithEmailAndPassword(getAuth(), Email, Password)
    .then(async (userCredential) => {
      const additionalUserInfo = getAdditionalUserInfo(userCredential);

      const { uid, phoneNumber } = userCredential.user;

      if (additionalUserInfo.isNewUser) {
        /**
         * Update user name as by default its null
         */
        await updateProfile(getAuth().currentUser, { displayName: Name });
        /**
         * If this social auth provider is used first by the user
         * an instance of the user will be stored in the server
         */
        const record = {
          uid,
          name: Name,
          email: Email,
          business: Business,
          password: sha256(Password),
          phoneNumber: phoneNumber || "",
        };
        await CreateUserRecord(record, additionalUserInfo);
        if (Business != null) {
          // For agents, it'll not register any business
          await CreateBusinessRecord(record, additionalUserInfo);
        }
      }

      /**
       * Get business information and seed in localstorage
       */
      if (Business != null) await SeedBusinessRecord(uid);

      /**
       * Get user role and seed in localstorage
       */
      await SeedUserRole(uid);

      /**
       * Setting Predefined custom fields in clients collection
       */
      await createSubCollectionInClient(await getCompleteCollection());

      return userCredential.user;
    })
    .catch((error) => {
      console.log(error);
      AuthErrorMessages(error.code);
      return false;
    });
};

// Retrieve firebase messaging
// eslint-disable-next-line no-undef
export const messaging = getMessaging(app);

let publicKey;

if (process.env.REACT_APP_MY_PRODUCTION == 0) {
  publicKey =
    "BLqhTdZX9zgz87xM2sB3s9rSj8e--3ZEEJXP3uYo-NL1bPdGcUxf8RsmiaaGWxXDBE8Dze15jsmaMMDXO7fhVaA";
} else {
  publicKey =
    "BPtF_Bjn_e67GCd2azLvfnJJx7wHsjf2TNzAkPvQOXAgHa_G4zUVgmiNfAmiUFCg2uwtGOhzMEEp14aBAdn3iR4";
}

export const getTokenFromFirebase = async (setTokenFound) => {
  let currentToken = "";
  let eError = "";
  const permission = await Notification.requestPermission();
  if (permission === "granted") {
    getToken(messaging, { vapidKey: publicKey })
      .then(async (currentToken) => {
        if (currentToken) {
          const userId = getAuth()?.currentUser?.uid;
          try {
            const deviceIdCollection = await doc(
              db,
              "users",
              userId,
              "device_ids",
              currentToken
            );
            await setDoc(deviceIdCollection, {
              token: currentToken,
            });
          } catch (error) {
            console.log(error);
          }
          setTokenFound(true);
          } else {
          setTokenFound(false);
    
        }
      })
      .catch((err) => {
        eError = err;
        console.log("An error occurred while retrieving token. ", eError);
        // ...
      });
  } else if (permission === "denied") {
    // alert("You denied for the notification");
  }

  return currentToken;
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
